__turbopack_export_value__({
  "body-logo-18": "Dropdown-module-scss-module__CnXb_G__body-logo-18",
  "body-text-12": "Dropdown-module-scss-module__CnXb_G__body-text-12",
  "body-text-14": "Dropdown-module-scss-module__CnXb_G__body-text-14",
  "body-text-16": "Dropdown-module-scss-module__CnXb_G__body-text-16",
  "body-text-18": "Dropdown-module-scss-module__CnXb_G__body-text-18",
  "body-text-20": "Dropdown-module-scss-module__CnXb_G__body-text-20",
  "body-text-24": "Dropdown-module-scss-module__CnXb_G__body-text-24",
  "body-text-24-2": "Dropdown-module-scss-module__CnXb_G__body-text-24-2",
  "body-text-heading-2": "Dropdown-module-scss-module__CnXb_G__body-text-heading-2",
  "body-text-heading-3": "Dropdown-module-scss-module__CnXb_G__body-text-heading-3",
  "body-text-medium-14": "Dropdown-module-scss-module__CnXb_G__body-text-medium-14",
  "body-text-medium-16": "Dropdown-module-scss-module__CnXb_G__body-text-medium-16",
  "body-text-medium-18": "Dropdown-module-scss-module__CnXb_G__body-text-medium-18",
  "body-text-medium2-18": "Dropdown-module-scss-module__CnXb_G__body-text-medium2-18",
  "body-text2-14": "Dropdown-module-scss-module__CnXb_G__body-text2-14",
  "body-text2-16": "Dropdown-module-scss-module__CnXb_G__body-text2-16",
  "button-primary-text": "Dropdown-module-scss-module__CnXb_G__button-primary-text",
  "button-text": "Dropdown-module-scss-module__CnXb_G__button-text",
  "button2-text": "Dropdown-module-scss-module__CnXb_G__button2-text",
  "card-shadow": "Dropdown-module-scss-module__CnXb_G__card-shadow",
  "dropdown": "Dropdown-module-scss-module__CnXb_G__dropdown",
  "dropdown__arrow": "Dropdown-module-scss-module__CnXb_G__dropdown__arrow",
  "dropdown__arrow_reverse": "Dropdown-module-scss-module__CnXb_G__dropdown__arrow_reverse",
  "dropdown__cross": "Dropdown-module-scss-module__CnXb_G__dropdown__cross",
  "dropdown__errorHint": "Dropdown-module-scss-module__CnXb_G__dropdown__errorHint",
  "dropdown__errorHint_visible": "Dropdown-module-scss-module__CnXb_G__dropdown__errorHint_visible",
  "dropdown__head": "Dropdown-module-scss-module__CnXb_G__dropdown__head",
  "dropdown__head_error": "Dropdown-module-scss-module__CnXb_G__dropdown__head_error",
  "dropdown__item": "Dropdown-module-scss-module__CnXb_G__dropdown__item",
  "dropdown__list": "Dropdown-module-scss-module__CnXb_G__dropdown__list",
  "dropdown__listWrapper": "Dropdown-module-scss-module__CnXb_G__dropdown__listWrapper",
  "dropdown__listWrapper_opened": "Dropdown-module-scss-module__CnXb_G__dropdown__listWrapper_opened",
  "dropdown__placeholder": "Dropdown-module-scss-module__CnXb_G__dropdown__placeholder",
  "effect-menu": "Dropdown-module-scss-module__CnXb_G__effect-menu",
  "header-1": "Dropdown-module-scss-module__CnXb_G__header-1",
  "main-container": "Dropdown-module-scss-module__CnXb_G__main-container",
  "main-footer-container": "Dropdown-module-scss-module__CnXb_G__main-footer-container",
  "main-header-container": "Dropdown-module-scss-module__CnXb_G__main-header-container",
  "txt-12-bold": "Dropdown-module-scss-module__CnXb_G__txt-12-bold",
  "txt-14-bold": "Dropdown-module-scss-module__CnXb_G__txt-14-bold",
  "txt-14-bold-caps": "Dropdown-module-scss-module__CnXb_G__txt-14-bold-caps",
  "txt-14-med": "Dropdown-module-scss-module__CnXb_G__txt-14-med",
  "txt-16-bold": "Dropdown-module-scss-module__CnXb_G__txt-16-bold",
  "txt-16-med": "Dropdown-module-scss-module__CnXb_G__txt-16-med",
  "txt-18-bold": "Dropdown-module-scss-module__CnXb_G__txt-18-bold",
  "txt-18-medium": "Dropdown-module-scss-module__CnXb_G__txt-18-medium",
  "txt-18-medium-24": "Dropdown-module-scss-module__CnXb_G__txt-18-medium-24",
  "txt-24-semi": "Dropdown-module-scss-module__CnXb_G__txt-24-semi",
});
